export default {
  getUnitOfMeasure: (state) => (id) => state.unitsOfMeasure.find((d) => d.id === id),
  getUnitsOfMeasure: (state) => state.unitsOfMeasure,
  getUnitOfMeasureName: (state) => (id) => state.unitsOfMeasure.find((d) => d.id === id)?.name,
};
